import React from 'react';
import styled, { css } from 'styled-components';
import {
  Dropdown,
  IconButton,
  TrevorIcon,
  WithTrevorComponentProps,
} from '@trevor/ui-components';
import ColumnName from '@/util/ColumnName';
import { ConfigurationOption } from './ConfigurationOption';
import {
  DisabledDropdownTrigger,
  DropdownContent,
  DropdownItem,
} from './ConfigurationSelect.styles';

export type ConfigurationSelectProps<T> = {
  index: Index;
  draggable: boolean;
  isRequired: boolean;
  options: T[];
  selectedOption: T;
  onSelectRemove: F<Index>;
  onOptionSelect: F2<Index, T>;
};

const _ConfigurationSelect = React.forwardRef<
  HTMLDivElement,
  WithTrevorComponentProps<ConfigurationSelectProps<ColumnName>>
>(
  (
    {
      className,
      index,
      options,
      selectedOption,
      onSelectRemove,
      onOptionSelect,
      draggable,
      isRequired: _isRequired,
      ...rest
    },
    ref,
  ) => {
    return (
      <div className={className} ref={ref} {...rest}>
        {options.length === 1 ? (
          <DisabledDropdownTrigger>
            {draggable && <TrevorIcon name="drag-reorder" color="#416288" />}

            <span>
              {selectedOption._name} {selectedOption._alias}
            </span>
          </DisabledDropdownTrigger>
        ) : (
          <Dropdown>
            <Dropdown.Trigger>
              <DropdownItem>
                {draggable && (
                  <TrevorIcon name="drag-reorder" color="#416288" />
                )}
                <span>
                  {selectedOption._name} {selectedOption._alias}
                </span>
                <TrevorIcon name="chevron-down" color="#416288" />
              </DropdownItem>
            </Dropdown.Trigger>
            <DropdownContent>
              {options.map((option) => (
                <ConfigurationOption
                  key={`${option._alias}.${option._name}`}
                  option={option}
                  selectedOption={selectedOption}
                  onSelect={() => onOptionSelect(index, option)}
                />
              ))}
            </DropdownContent>
          </Dropdown>
        )}

        <IconButton
          icon={<TrevorIcon name="trash-bin" color="#416288" />}
          onClick={() => onSelectRemove(index)}
        />
      </div>
    );
  },
);

export const ConfigurationSelect = styled(_ConfigurationSelect)`
  display: flex;
  align-items: center;
  margin-bottom: var(--spacing-s);
  background-color: #fff;

  ${(p) =>
    p.isRequired &&
    css`
      ${IconButton} {
        //visibility: hidden; // NOTE: this doesn't work as expected
        opacity: 0;
        pointer-events: none;
      }
    `}

  ${Dropdown},
  ${DisabledDropdownTrigger} {
    flex-grow: 1;
    margin-right: var(--spacing-m);
  }
`;
